import React from "react";
import CommonFiveTextDetails from "../common/CommonFiveTextDetails";
import DisplaySelectedOptionsList from "../common/DisplaySelectedOptionsList";
import LinkBorderCommonButton from "../common/LinkBorderCommonButton";
import { agencyDashboardClientProfile } from "../common/allLinks";

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
];

export default function ClientPreviewRequirementCard({
  isDisplayAboutCompanyButton,
}) {
  return (
    <div className="client-dashboard-preview-requirement-card">
      <div className="custom-d-flex flex-nowrap justify-content-between align-items-center client-dashboard-preview-requirement-card-title-div">
        <div className="col-12 col-md-10">
          <h5 className="font-24-NunitoSans-600">We are looking for</h5>
          <h2 className="font-48-NunitoSans-600 pt-25">
            3 MERN Stack Developers
          </h2>
          <div className="custom-d-flex mt-50 alignn-items-center flex-nowrap">
            <CommonFiveTextDetails />
          </div>
        </div>
        <div className="col-12 col-md-2 text-md-right">
          <h5 className="client-dashboard-preview-requirement-card-resource-text">
            24 <br className="d-none d-md-block" />
            <span className="font-24-NunitoSans-600">$ /Hr /Resource</span>
          </h5>
        </div>
      </div>
      <div className="custom-d-flex flex-nowrap client-dashboard-preview-requirement-card-middle-div">
        <div className="col-12 col-md-6 client-dashboard-preview-requirement-card-middle-left-div">
          <div>
            <h3 className="font-24-NunitoSans-600">Description</h3>
            <p className="font-18-nunito-light color-white-66 pt-35">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
            <p className="font-18-nunito-light color-white-66 pt-20">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
            <p className="font-18-nunito-light color-white-66 pt-20">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div>
            <h3 className="font-24-NunitoSans-600 pt-25">
              Expectations from Resources
            </h3>
            <p className="font-18-nunito-light color-white-66 pt-20">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>
        <div className="col-12 col-md-6 client-dashboard-preview-requirement-card-middle-right-div mobile-mt-20">
          <div>
            <h3 className="font-24-NunitoSans-600">Required Skills</h3>
            <div className="custom-d-flex flex-wrap align-items-start mt-34">
              {/* {dummyData.map((data, index) => (
                <Fragment key={index}>
                  <div className="font-18-nunito-semibold  client-dashboard-preview-requirement-card-tg">
                    <span>Skill Name</span>
                  </div>
                </Fragment>
              ))} */}
              <DisplaySelectedOptionsList
                displayListSelected={optionsSkill}
                isDisplayRemoveIcon={false}
              />
            </div>
          </div>
          <div>
            <h3 className="font-24-NunitoSans-600 mt-50">
              Minimum Years of Experience
            </h3>
            <h5 className="font-18-nunito-light color-white-66 pt-25">
              3 Years
            </h5>
          </div>
          <div className="mt-50">
            <h3 className="font-24-NunitoSans-600">Minimum Education Level</h3>
            <h5 className="font-18-nunito-light color-white-66 pt-20">
              Graduate
            </h5>
          </div>
          <div className="mt-50">
            <h3 className="font-24-NunitoSans-600">Urgency</h3>
            <h5 className="font-18-nunito-light pt-20 color-white-66">
              About the Employer
            </h5>
          </div>
        </div>
      </div>
      <div className="client-dashboard-preview-requirement-card-bottom-div">
        <h3 className="font-24-NunitoSans-600">This Week</h3>
        <div className="custom-d-flex justify-content-between pt-35 align-items-center flex-nowrap">
          <div className="d-flex align-items-start flex-nowrap mb-23">
            <div className="client-dashboard-preview-requirement-card-profile-img flex-shrink-0"></div>
            <div>
              <h4 className="font-36-nunito-semibold">Honda</h4>
              <div className="custom-d-flex align-items-center pt-25 flex-nowrap">
                <h4 className="font-16-NunitoSans-600 client-dashboard-preview-requirement-card-client-mail-text color-white-66 d-flex flex-nowrap pr-25 align-items-center">
                  <img
                    src={"/img/desktop/icons/gray-profile-icon.svg"}
                    alt=""
                    className="client-dashboard-preview-requirement-card-profile-icon"
                  />
                  Rajesh Chopra
                </h4>
                <h4 className="font-16-NunitoSans-600  client-dashboard-preview-requirement-card-client-mail-text color-white-66 d-flex flex-nowrap pr-25 align-items-center">
                  <img
                    src={"/img/desktop/icons/gray-message-icon.svg"}
                    alt=""
                    className="client-dashboard-preview-requirement-card-message-icon"
                  />
                  Rajes@mail.com
                </h4>
                <h4 className="font-16-NunitoSans-600 color-white-66 d-flex flex-nowrap pr-25 align-items-center">
                  <img
                    src={"/img/desktop/icons/gray-phone-icon.svg"}
                    alt=""
                    className="client-dashboard-preview-requirement-card-call-icon"
                  />
                  +91-1431231345
                </h4>
              </div>
            </div>
          </div>
          <div className="text-right">
            <h5 className="font-18-nunito-light color-white-66 mb-23">
              Posted on 12/4/19
            </h5>
            {isDisplayAboutCompanyButton && (
              <LinkBorderCommonButton
                extraClassName="login-btn-link--preview"
                linkText="About Company"
                linkPath={agencyDashboardClientProfile}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

ClientPreviewRequirementCard.defaultProps = {
  isDisplayAboutCompanyButton: false,
};
